"use client";
import { jsx } from "react/jsx-runtime";
import { Drawer } from "@base-ui/react/drawer";
import { Popover } from "@base-ui/react/popover";
import { forwardRef } from "react";
import { cn } from "../../utils/cn.js";
import { popoverVariants } from "./Popover.variants.js";
import { usePopoverMode } from "./PopoverContext.js";
const PopoverTitle_PopoverTitle = /*#__PURE__*/ forwardRef(function({ className, slots, ...props }, ref) {
    const mode = usePopoverMode();
    const { title } = popoverVariants();
    const classes = cn(title(), className, slots?.title);
    if ('drawer' === mode) return /*#__PURE__*/ jsx(Drawer.Title, {
        ref: ref,
        className: classes,
        ...props
    });
    return /*#__PURE__*/ jsx(Popover.Title, {
        ref: ref,
        className: classes,
        ...props
    });
});
export { PopoverTitle_PopoverTitle as PopoverTitle };
